import { ErrorMessage } from '@hookform/error-message'
import { FunctionComponent } from 'react'
import DatePicker from 'react-datepicker'
import { Control, Controller } from 'react-hook-form'
import { Icon } from 'utils'

export type DateUpdateType = { date: Date; name: string }

interface DateSelectorInterface {
  control: Control<Record<string, any>>
  id: string
  name: string
  label: string
  minDate?: Date
  maxDate?: Date
  errorMessage?: string
  required: boolean
  defaultValue?: string
}

const DateSelector: FunctionComponent<DateSelectorInterface> = ({
  control,
  id,
  name,
  label,
  minDate,
  maxDate,
  errorMessage,
  required = true,
  defaultValue
}) => {
  return (
    <div className="wc-form-item wc-form-item w-auto sm:w-5/12 md:w-6/12 lg:w-5/12">
      <label htmlFor={id} className="label-primary">
        {label}
      </label>
      <Controller
        control={control}
        name={name}
        rules={{ required }}
        defaultValue={defaultValue}
        render={({
          field: { onChange, onBlur, value },
          formState: { errors }
        }) => (
          <>
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => (
                <span
                  className="field-validation-error wc-assist wc-assist--error"
                  role="alert"
                >
                  {message}
                </span>
              )}
            />
              <DatePicker
                id={id}
                className={`input-calendar${errorMessage ? ' invalid' : ''}}`}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                selected={value ? new Date(value) : undefined}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(date) => {
                  const d = date && !Array.isArray(date) && date
                  if (d) {
                    onChange(d)
                  }
                }}
                onBlur={onBlur}
              />
            {errorMessage && !value && (
              <span
                className="field-validation-error wc-assist wc-assist__bottom wc-assist--error"
                role="alert"
              >
                Please select a date
              </span>
            )}
          </>
        )}
      />
    </div>
  )
}

export default DateSelector
